import { render } from "./headerComp.vue?vue&type=template&id=a35840e2&scoped=true"
import script from "./headerComp.vue?vue&type=script&lang=js"
export * from "./headerComp.vue?vue&type=script&lang=js"

import "./headerComp.vue?vue&type=style&index=0&id=a35840e2&lang=scss&scoped=true"

import exportComponent from "C:\\workspace\\repository\\sprfidspring\\src\\main\\vue-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a35840e2"]])

export default __exports__